import { render, staticRenderFns } from "./teacher-checking.vue?vue&type=template&id=9d371ae2&scoped=true&"
import script from "./teacher-checking.vue?vue&type=script&lang=js&"
export * from "./teacher-checking.vue?vue&type=script&lang=js&"
import style0 from "./teacher-checking.vue?vue&type=style&index=0&id=9d371ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d371ae2",
  null
  
)

export default component.exports